module.exports = __webpack_public_path__ + "img/46-russia.2f9b9a11.svg";